import { Layout } from "antd";
import { useEffect, useRef } from "react";
import { ProfileMenu } from "./ProfileMenu";
import { useAuth } from "../../../../api/auth/useAuth";
import { Button } from "../../../components/CustomAntdComponents/Button";
import { useNavigate } from "react-router-dom";
import { Link } from "../../../../router/LocaleLink";
import { Paths, PathGenerators } from "../../../../router/paths";
import { useAuthEntryPath } from "../../../../router/useAuthEntryPath";
import { StockSearch } from "../../../components/StockSearch";
import { NotificationsMenu } from "./NotificationsMenu";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "../../../../components/LanguageSwitcher";
import styles from "./index.module.css";

const { Header: AntdHeader } = Layout;

export const Header = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const loginPath = useAuthEntryPath(Paths.LOGIN);
  const signUpPath = useAuthEntryPath(Paths.SIGN_UP);
  const searchContainerRef = useRef<HTMLDivElement | null>(null);

  const handleStockSelect = (symbol: string) => {
    navigate(PathGenerators.SYMBOL(symbol));
  };


  useEffect(() => {
    if (typeof window === "undefined") return;

    const isMac =
      typeof navigator !== "undefined" &&
      navigator.platform.toUpperCase().includes("MAC");

    const handleKeyDown = (event: KeyboardEvent) => {
      const isMetaOrCtrl = isMac ? event.metaKey : event.ctrlKey;

      if (
        !isMetaOrCtrl ||
        event.key.toLowerCase() !== "k" ||
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement ||
        (event.target as HTMLElement | null)?.isContentEditable
      ) {
        return;
      }

      event.preventDefault();

      const inputElement =
        searchContainerRef.current?.querySelector<HTMLInputElement>("input");

      if (inputElement) {
        inputElement.focus();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    // Desktop header; hidden below 1167px by CSS, where MobileSidebar's bar
    (
      <AntdHeader className={styles.header} data-sticky-header>
        <div className={styles.headerContent}>
          <div className={styles.headerLeft}>
            <div ref={searchContainerRef} className={styles.searchWrapper}>
              <StockSearch
                width="100%"
                placeholder={t("layout.searchStocks")}
                actionLabel={t("layout.search")}
                onSelect={handleStockSelect}
              />
            </div>
          </div>
          <div className={styles.headerRight}>
            <LanguageSwitcher />
            {user ? (
              <>
                <NotificationsMenu />
                <ProfileMenu />
              </>
            ) : (
              <>
                <Link to={loginPath}>
                  <Button type="default">{t("layout.login")}</Button>
                </Link>
                <Link to={signUpPath}>
                  <Button type="primary">{t("layout.signUp")}</Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </AntdHeader>
    )
  );
};
